import { render } from "./BaseLoading.vue?vue&type=template&id=9cef3a32&scoped=true"
import script from "./BaseLoading.vue?vue&type=script&lang=js"
export * from "./BaseLoading.vue?vue&type=script&lang=js"

import "./BaseLoading.vue?vue&type=style&index=0&id=9cef3a32&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cef3a32"]])

export default __exports__